import React from "react";

const columns = [
  "Student",
  "Current Campus / Shliach",
  "Reward",
  "Credits / Total Value",
  "Request Received",
  "Status",
  "Approve / Deny",
];

export default function RewardRequestsTableHeader() {
  return (
    <div className="courses-requests-table-header">
      {columns.map((column, index) => (
        <p className="flex flex-align-center" key={index}>
          {column}
        </p>
      ))}
    </div>
  );
}
